// File 3: Updated RestaurantLayout to work with new routing structure
// src/pages/restaurant/RestaurantLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";

const RestaurantLayout: React.FC = () => {
  return <Outlet />;
};
export default RestaurantLayout;
